module.exports = __webpack_public_path__ + "img/Add_content_type_button.d2fe7495.png";